/* @flow */
import gql from 'graphql-tag';

import type {ListingImage} from '../Hit/Hit';

// npm repo @homeaway/graphql-traveler-property
const query = gql`
    query imagesForListing($listingId: String!) {
        listing(listingId: $listingId) {
            images {
                c6_uri
                altText
            }
        }
    }
`;

type FetchListingImagesParams = {
    client: any,
    listingId: string
};

export function fetchListingImages({
    client,
    listingId
}: FetchListingImagesParams): Promise<?Array<ListingImage>> {
    return client
        .query({
            query,
            variables: {
                listingId
            }
        })
        .then(
            (response) => response.data.listing && response.data.listing.images
        );
}

export default {
    fetchListingImages
};
